import { useState } from "react";

const faqs = [
  {
    q: "How do I get an expedited passport in Rapid City, South Dakota?",
    a: "Rapid City residents can use Fast Passport Center for 2–9 day expedited processing. Submit your application, visit a local acceptance facility, then ship your documents to us overnight. We handle the agency submission — no trip to Denver required.",
  },
  {
    q: "Where is the nearest passport agency to Rapid City?",
    a: "The Denver Regional Passport Agency (1961 Stout St, Denver, CO) is approximately 360 miles south of Rapid City via I-90 and I-25. It requires an appointment for genuine emergencies only. Fast Passport Center eliminates that drive for most applicants.",
  },
  {
    q: "What is the fastest way to get a passport in Rapid City?",
    a: "For true emergencies (travel within 72 hours), you may qualify for same-day processing via the Denver agency. For most travelers, Fast Passport Center offers 2–9 day processing without leaving Rapid City.",
  },
  {
    q: "Can I get a passport at the Rapid City post office?",
    a: "Yes — Rapid City post offices serve as acceptance facilities where you submit your DS-11 or DS-82 application, photos, and supporting documents. However, routine postal processing takes 6–11 weeks. Fast Passport Center can expedite this to 2–9 days.",
  },
  {
    q: "How long does passport renewal take for Rapid City residents?",
    a: "Routine renewal via USPS takes 6–11 weeks from Rapid City. Expedited via post office is 3–5 weeks. Fast Passport Center offers 2–9 business day processing using our registered courier submission channels.",
  },
  {
    q: "Does Rapid City have a passport agency?",
    a: "Rapid City does not have a regional passport agency. The nearest full-service agency is in Denver, CO (360+ miles). Acceptance facilities (post offices, clerk offices) can accept applications but cannot process them quickly.",
  },
  {
    q: "Can military families at Ellsworth AFB use your service?",
    a: "Yes. Military families at Ellsworth AFB in Box Elder are fully eligible for our expedited passport services. We serve the entire Rapid City metro including Box Elder, and understand the unique needs of military families with frequent PCS moves and international travel.",
  },
  {
    q: "Can I use Fast Passport Center for Mount Rushmore / Black Hills trips?",
    a: "If your international travel plans take you beyond the Black Hills, we handle your passport fast. We serve all of Pennington County, Meade County, Lawrence County, and surrounding Black Hills communities.",
  },
];

export default function FAQSection() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked Questions — Rapid City Passports
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base">
            Everything Rapid City residents ask about expedited passport services. Don&apos;t see your question? Call us directly.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-[#F7F8FA] transition-colors"
              >
                <h4>
                  <a className="font-semibold text-[#1A365D] text-sm pr-4">{faq.q}</a>
                </h4>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`${open === i ? "ri-subtract-line" : "ri-add-line"} text-[#1A365D] text-lg`}></i>
                </div>
              </button>
              {open === i && (
                <div className="px-5 pb-4">
                  <p className="text-gray-500 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}